module.exports = __webpack_public_path__ + "img/Helm_verplicht.92308300.jpg";